import React from 'react'
import { TModuleHeader } from './_types'
import ComponentButton from '../../components/ComponentButton'

const ModuleHeader: React.FC<TModuleHeader> = ({ settings: { title, description, has_dms_group }, components }) => {
    const buttons = Array.isArray(components) ? [] : components?.buttons ?? []

    const renderTitle = (t: string | string[] | undefined) => {
        if (!t) return null
        if (Array.isArray(t)) {
            return t.map((line, i) => (
                <div className='moduleHeader_titleLine' key={i}>
                    {line}
                </div>
            ))
        }
        return <>{t}</>
    }

    const renderDescription = (d: string | undefined) => {
        if (!d) return null

        return d.split('\n\n').map((para, i) => (
            <p className='moduleHeader_descriptionParagraph' key={i}>
                {para.split('\n').map((line, j, arr) => (
                    <React.Fragment key={j}>
                        {line}
                        {j < arr.length - 1 ? <br /> : null}
                    </React.Fragment>
                ))}
            </p>
        ))
    }

    return (
        <div className='moduleHeader'>
            <div className='moduleHeader_properties'>
                <div className='moduleHeader_title'>
                    {renderTitle(title)}
                    {has_dms_group && (
                        <span className='moduleHeader_dmsLabel'>ДМС</span>
                    )}
                </div>
                <div className='moduleHeader_description'>{renderDescription(description)}</div>
            </div>
            <div className='moduleHeader_buttons'>
                {buttons.map((button) => (
                    <ComponentButton key={button.settings.title} {...button} />
                ))}
            </div>
        </div>
    )
}

export default ModuleHeader
